import Vue from 'vue';
import Dayjs from '@/plugins/day';
import axios from 'axios';
import vuetify from '@/plugins/vuetify';
import gettext from '@/plugins/vue-gettext';
import mixins from '@/plugins/mixins';
import router from '@/router';
import store from '@/store';
import App from '@/App.vue';
import SvgSprite from '@/components/SvgSprite.vue';
import VImage from '@/components/VImage.vue';
import AvatarComponent from '@/components/Avatar/AvatarComponent.vue';
import 'whatwg-fetch';
import VueMeta from 'vue-meta';
import UniqueId from 'vue-unique-id';
import gtm from '@/plugins/gtm';
import * as VueGoogleMaps from 'vue2-google-maps'

// import plugin tiptap-vuetify
import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
import 'tiptap-vuetify/dist/main.css'
import 'vuetify/dist/vuetify.min.css'
Vue.use(TiptapVuetifyPlugin, {
  vuetify,
  iconsGroup: 'fa'
})

// toast
import AWN from "awesome-notifications";
Vue.prototype.$toast = new AWN({
  position: 'bottom-right'
});

// crop image
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
Vue.component('vue-cropper', VueCropper);

// setup
Vue.prototype.$http = axios;
Vue.prototype.store = store;
Vue.prototype.router = router;
Vue.config.productionTip = true;
Vue.use(VueMeta);
Vue.use(UniqueId);

Vue.mixin(mixins);

/* Plugins */
Vue.use(Dayjs, {
  lang: 'en',
  filters: {
    ago: 'ago',
  },
});
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAP_API_KEY,
    libraries: 'places',
  },
})
/* Components */
Vue.component('icon', SvgSprite);
Vue.component('v-image', VImage);
Vue.component('AvatarComponent', AvatarComponent);

new Vue({
  gettext,
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app')